import React, { useCallback, useEffect, useState } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
import ProjectStatus from "./ProjectStatus";
import StandardSurveyForm from "./StandardSurveyForm";
import DynamicForm from "./DynamicForm";
// import UserTable from "../../../components/common/UserTable";
import AssignedForm from "../AssignedForm/AssignedForm";
import UserDetailPage from "../../../components/common/UserDetailPage/UserDetailPage";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import dayjs from "dayjs";
import { Button } from "antd";
import Report from "../../../components/common/Report";
import ProjectsReport from "./ProjectsReport";
import UserTable from "../../Customer/CustomerDetailPage/UserTable";
const ProjectDetailPage = () => {
  const [openAssignedForm, setOpenAssignedForm] = useState(false);
  const [openUserDetailsPage, setOpenUserDetailsPage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const projectId = location.state || {};
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [projectData, setProjectData] = useState({});
  const [data, setData] = useState([]);
  const [clientId, setClientId] = useState();
  const [assignedFormType, setAssignedFormtype] = useState("");
  const [projectSetup, setProjectSetup] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [formId, setFormId] = useState(null);

  const handleAssigned = useCallback(() => {
    setOpenAssignedForm(true);
  }, []);

  const getProjectDetails = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
      });
      if (response.success) {
        let project_Data = response.data;
        setProjectData({
          projectId: project_Data._id,
          projectName: project_Data.name,
          startDate: dayjs(project_Data.startDate).format("DD/MMM/YYYY"),
          endDate: project_Data.endDate
            ? dayjs(project_Data.endDate).format("DD/MMM/YYYY")
            : "",
          projectType: project_Data.project_type,
          ...project_Data,
        });
      }
      setClientId(response.data.assigned_by || response.data.client_id);
    } catch (error) {
      console.error("Error in fetching project data", error);
    } finally {
      setProjectSetup(false);
    }
  }, [projectSetup]);

  useEffect(() => {
    getProjectDetails();
  }, [projectSetup]);
  const clientName = clientId?.organization?.name||clientId?.name || "";
  return (
    <div
      style={{ padding: "20px", backgroundColor: "#fff" }}
      // className="h-screen"
    >
      {!openUserDetailsPage ? (
        <div>
          <div
            className="flex justify-end  text-xs"
            style={{ fontFamily: "Calibri" }}
          >
            <p>Home </p>
            <span> / </span>
            <p>Projects </p> <span> / </span>
            <TextStyles color="gradient"> Project Detail Page</TextStyles>
          </div>
          <div className="flex justify-start cursor-pointer ">
            <div>
              <BackIcon
                onClick={() => {
                  navigate("/projects");
                }}
              />
            </div>
            <div className="items-center mt-3">
              <TextStyles color="gradient" style={{ fontSize: "20px" }}>
                Project Detail Page - {clientName}
              </TextStyles>
            </div>
          </div>

          <CardsBorder>
            <ProjectStatus
              projectData={projectData}
              projectId={projectId.projectId}
              setProjectSetup={setProjectSetup}
              data={data}
            />
          </CardsBorder>

          {!openAssignedForm ? (
            <div>
              <div className="mt-5">
                <CardsBorder>
                  <StandardSurveyForm
                    setOpenAssignedForm={handleAssigned}
                    projectId={projectId.projectId}
                    setAssignedFormtype={setAssignedFormtype}
                    setSelectedRole={setSelectedRole}
                    projectSetup={projectSetup}
                  />
                </CardsBorder>
              </div>
              <div className="mt-5">
                <CardsBorder>
                  <DynamicForm
                    projectId={projectId.projectId}
                    setOpenAssignedForm={handleAssigned}
                    setAssignedFormtype={setAssignedFormtype}
                    clientId={clientId}
                    setSelectedRole={setSelectedRole}
                    projectSetup={projectSetup}
                  />
                </CardsBorder>
              </div>{" "}
            </div>
          ) : (
            <div className="my-4 mx-8">
              <div className="flex justify-end mb-2">
                <Button
                  type="primary"
                  style={{
                    background: "#06513D",
                    height: "50px",
                    width: "150px",
                    borderRadius: "10px",
                  }}
                  className="text-xs font-light"
                  onClick={() => setOpenAssignedForm(false)}
                >
                  Assigned Form
                </Button>
              </div>
              <AssignedForm
                projectId={projectId.projectId}
                selectedRows={selectedUsers}
                assignedFormType={assignedFormType}
                selectedRole={selectedRole}
                clientId={clientId?._id}
                setSelectedRole={setSelectedRole}
                formId={formId}
                setFormId={setFormId}
              />
            </div>
          )}
          <div className="mt-5">
            <UserTable
              showCheckboxes={openAssignedForm}
              selectedRows={selectedUsers}
              projectId={projectId.projectId}
              setSelectedRows={setSelectedUsers}
              assignedFormType={assignedFormType}
              setOpenUserDetailsPage={setOpenUserDetailsPage}
              clientId={clientId?._id}
              selectedRole={selectedRole}
              formId={formId}
              noPadding={true}
            />
          </div>

          <div className="my-5">
            <CardsBorder>
              <ProjectsReport
                projectId={projectId.projectId}
                clientId={clientId?._id}
              />
            </CardsBorder>
          </div>
        </div>
      ) : (
        <div>
          <UserDetailPage setOpenUserDetailsPage={setOpenUserDetailsPage} />
        </div>
      )}
    </div>
  );
};

export default ProjectDetailPage;
